



 export const localRouter_meun_land = [ //产业招商大脑导航栏顺序
    //工作台
{
    code: "E",
    switch: true,
    name: "",
    oldtext: "拿地项目库检索",
    type: "ndjs",
    url: "/landSearch",
    open: false,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},
{
    code: "B",
    switch: true,
    name: "",
    oldtext: "土地信息监测",
    type: "pxm",
    url: "/landMonitor",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},


//个人中心
{
    code: "H",
    switch: true,
    name: "",
    oldtext: "个人中心",
    url: "/baseInformation",
    open: false,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-custom",
    children: []
},
]
 